import RestaurantsApi from '../api/restaurants'
import { Promise } from 'es6-promise'
import qs from 'query-string'
import { push } from 'react-router-redux'

export const SEARCH_RESTAURANTS_REQUESTED = 'restaurantSearch/SEARCH_RESTAURANTS_REQUESTED'
export const SEARCH_RESTAURANTS_DONE = 'restaurantSearch/SEARCH_RESTAURANTS_DONE'
export const SEARCH_RESTAURANTS_ERROR = 'restaurantSearch/SEARCH_RESTAURANTS_ERROR'
export const SEARCH_RESTAURANTS_RESET = 'restaurantSearch/SEARCH_RESTAURANTS_RESET'

export const SEARCH_RESTAURANTS_TYPE_RESTAURANT_ID = 'id'
export const SEARCH_RESTAURANTS_TYPE_RESTAURANT_NAME = 'name'
export const SEARCH_RESTAURANTS_TYPE_POOL_ID = 'poolId'

export const resetSearchRestaurants = () => {
  return dispatch => {
    dispatch({
      type: SEARCH_RESTAURANTS_RESET,
    })
  }
}

export const gotoSearchResults = (searchText, searchType) => {
  return dispatch => {
    dispatch({
      type: SEARCH_RESTAURANTS_RESET,
    })
    dispatch(push('/restaurants/search?' + qs.stringify({
      q: searchText,
      qt: searchType,
      page: 1
    })))
  }
}

export const gotoRestaurantDetails = (restaurantId) => {
  return dispatch => dispatch(push('/restaurants/' + restaurantId))
}

export const searchRestaurantsAsync = (searchText, searchType, offset, limit) => {
  return dispatch => {

    dispatch({
      type: SEARCH_RESTAURANTS_REQUESTED,
      searchText: searchText,
      searchType: searchType,
      offset: (offset || 0)
    })

    let cleanedSearchText = (searchText || '').trim()
    if (searchType === SEARCH_RESTAURANTS_TYPE_RESTAURANT_NAME && cleanedSearchText.length < 3) {
      dispatch({
        type: SEARCH_RESTAURANTS_DONE,
        foundRestaurants: null,
        error: 'No search done. filter too short'
      })
      return
    }

    if (searchType === SEARCH_RESTAURANTS_TYPE_RESTAURANT_ID && /[^0-9]/.test(cleanedSearchText)) {
      dispatch({
        type: SEARCH_RESTAURANTS_DONE,
        foundRestaurants: null,
        error: 'Restaurant ID should be a number'
      })
      return
    }

    let searchReq
    if (searchType === SEARCH_RESTAURANTS_TYPE_RESTAURANT_NAME) {
      searchReq = RestaurantsApi.SearchByName(cleanedSearchText, offset, limit)
        .then(response => response.json())
    }
    else if (searchType === SEARCH_RESTAURANTS_TYPE_RESTAURANT_ID) {
      searchReq = RestaurantsApi.GetById(cleanedSearchText)
        .then(response => response.status === 404
          ? { totalItems: 0, data: [] }
          : response.json().then(json => ({ totalItems: 1, data: [json] })))

    }
    else if (searchType === SEARCH_RESTAURANTS_TYPE_POOL_ID) {
      cleanedSearchText = cleanedSearchText.toLowerCase() === "no pool" ? "" : cleanedSearchText;
      searchReq = RestaurantsApi.SearchByPoolId(cleanedSearchText, offset, limit)
        .then(response => response.json())
    }
    else {
      searchReq = Promise.reject({ message: `Unknown search type '${searchType}'` })
    }

    searchReq.then(json => {
      dispatch({
        type: SEARCH_RESTAURANTS_DONE,
        foundRestaurants: json,
      })
    })
      .catch(function (error) {
        dispatch({
          type: SEARCH_RESTAURANTS_ERROR,
          error: error.message
        })
        console.log('There has been a problem searching restaurants: ', error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/restaurantSearch.js